import { render, staticRenderFns } from "./Tarifs.vue?vue&type=template&id=62cf4e93"
import script from "./Tarifs.vue?vue&type=script&lang=js"
export * from "./Tarifs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports